import { post } from '@/utils/request'

// 获取店铺列表
export function shopList(data) {
  return post('/admin/edu_youth_order/shopList', data)
}

// 获取店铺详情
export function shopDetail(data) {
  return post('/admin/edu_youth_order/shopDetail', data)
}

// 店铺审核同意
export function shopApprove(data) {
  return post('/admin/edu_youth_order/shopApprove', data)
}

// 店铺审核拒绝
export function shopReject(data) {
  return post('/admin/edu_youth_order/shopReject', data)
}